"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const FilterDatePicker = () => {
    return ((0, jsx_runtime_1.jsx)("div", { className: 'k-filtercell' }));
};
exports.default = FilterDatePicker;
